module.exports = __webpack_public_path__ + "static/media/SUV-icon.bb86c5ee.svg";